<template>
  <div class="contentPage">
    <div class="potential">
      <div class="potential_title">
        <span>Potential client list</span>
        <div class="blockRight">
          <button @click="onRefresh" class="mainBtn mainBtn-text">
            <span class="btnIco">
              <svg-sprite width="20" height="20" icon-id="refresh"></svg-sprite>
            </span>
            <span class="btnText">refresh</span>
          </button>
          <button @click="onUploadComponent(true)" class="mainBtn mainBtn-text">
            <span class="btnIco">
              <svg-sprite width="20" height="20" icon-id="upload"></svg-sprite>
            </span>
            <span class="btnText">Upload</span>
          </button>
          <button @click="onAddClient" class="mainBtn">
            <span class="btnText">Create client</span>
          </button>
        </div>
      </div>
      <div class="potential_body">
        <tab-block
          :tab="tab"
          :tab-list="tabList"
          custom-class="clientTabs"
          @updateTab="onTab($event)"
        >
          <v-tab-item :key="flag" v-for="({flag}) in tabList">
            <main-table
                padding="0 0 10px"
                :flag="flag"
                :headers="headers"
                :filters-list="potentialClientsFilter"
                :list-items="potentialClientsList"
                :is-hide-header="false"
                :items-per-page-amount="10"
                :pages="[10, 20, 50, 100, 200, 500, 'All']"
                :uniqId="isRefreshFilters"
                @updateClickButton="onClickButton"
                @updateEdit="onEdit"
                @updateChangeSort="onFilter"
                @updateRefreshFilters="onRefreshFilters"
            ></main-table>
          </v-tab-item>
        </tab-block>
      </div>
    </div>
    <add-potential-client
      v-if="isPotentialClient"
      :currentId="currentId"
      :typeDefault="type"
      :getPermissionAction="getPermissionAction"
      :permissions="permissions"
      @updateClose="onAddPotentialClients(false)"
      @updateFilterList="onFilterList"
    ></add-potential-client>
    <remove-block
      v-if="isRemove"
      @updateRemoveItem="onRemoveItem"
      @updateRemoveClose="onRemoveClose"
    ></remove-block>
    <table-settings
        v-if="isTableSettingsDrawer"
        @updateSettingsSave="onSettingsSave('potentialClients')"
        @updateSettingsCancel="onSettingsCancel"
        @updateSettingsClose="onSettingsClose"
        @updateSettingsAll="onSettingsAll"
        :settings="getSettings"
    ></table-settings>
    <upload-component
      v-if="isUploadComponent"
      :keys-request="{
        get: 'onPotentialClientsImport',
        set: 'onPotentialClientsImportSave',
      }"
      key-header="updateClientsHeader"
      @updateClose="onUploadComponent(false)"
    ></upload-component>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
// async components
const AddPotentialClient = () => import("@/components/Maintenance/PotentialClient/AddPotentialClient/AddPotentialClient");
const RemoveBlock = () => import("@/shared/RemoveBlock/RemoveBlock");
const UploadComponent = () => import("@/shared/UploadComponent/UploadComponent");
// shared
import TabBlock from "@/shared/TabBlock/TabBlock";
// helper
import getUniqId from "@/helper/getUniqId";
import getClonedObject from "@/helper/getClonedObject";
// constants
import { PERMISSIONS } from "@/constants/constants";
import debounce from "lodash.debounce";
import settingsMixins from "@/mixins/settingsMixins";
import potentialClientsTabs from "@/pages/Maintenance/PotentialClient/potentialClientsTabs";

export default {
	name: "PotentialClient",
	mixins: [ settingsMixins ],
	components: {
		TabBlock,
		AddPotentialClient,
		RemoveBlock,
		UploadComponent,
	},
	computed: {
		...mapGetters([ "potentialClientsFilter", "potentialClientsList", "permissions" ]),
		getPermissionAction() {
			if (
				(this.permissions[PERMISSIONS.CREATE] && !this.currentId) ||
        this.permissions[PERMISSIONS.EDIT]
			)
				return false;
			return this.permissions[PERMISSIONS.VIEW];
		},
	},
	data: () => ({
		tabList: [],
		tab: 0,
		type: 1,
		isRefresh: null,
		isFilterList: null,
		isPotentialClient: false,
		currentId: null,
		isRemove: false,
		removeId: null,
		isCommentsPopup: false,
		isUploadComponent: false,
		uniqId: null,
		isRefreshFilters: null,
	}),
	methods: {
		...mapActions([
			"onPotentialClients",
			"onRemovePotentialClients",
			"onClearPotentialClientsFilter",
			"onPotentialClientsFilter",
			"onPotentialClientsCreate",
		]),
		onAddClient() {
			this.isPotentialClient = true;
		},
		async onTab(value) {
			const { type } = this.tabList[value];
			await this.onPotentialClientsFilter({ type });
			this.tab = value;
			this.type = type;
		},
		onEvent({ flag }) {
			if (flag === "upload") this.isUploadComponent = true;
		},
		onUploadComponent(value) {
			this.isUploadComponent = value;
		},
		onRefresh() {
			this.isRefreshFilters = getUniqId();
		},
		onRefreshFilters: debounce(async function() {
			await this.onPotentialClientsFilter({ type: this.type });
		}, 300),
		async onFilter(info) {
			this.filterModList = info.filterModList;
			await this.onPotentialClientsFilter({
				type: this.type,
				...info.filterModList,
			});
		},
		onClickButton({ key, item }) {
			if (key === "delete") {
				if (this.permissions[PERMISSIONS.DELETE]) {
					this.getRemoveItem(item.id);
				}
			}

			if (key === "edit") {
				if (
					this.permissions[PERMISSIONS.EDIT] ||
          this.permissions[PERMISSIONS.VIEW]
				) {
					this.currentId = item.id;
					this.isPotentialClient = true;
				}
			}
		},
		async onCreate() {
			this.currentId = null;
			this.isPotentialClient = true;
		},
		onEditMain({ line }) {
			if (
				this.permissions[PERMISSIONS.EDIT] ||
        this.permissions[PERMISSIONS.VIEW]
			) {
				this.currentId = line.id;
				this.isPotentialClient = true;
			}
		},
		refreshFilters() {
			this.isRefresh = getUniqId();
		},
		onFilterList() {
			this.isFilterList = getUniqId();
		},
		onRemoveClose() {
			this.isRemove = false;
		},
		onAddPotentialClients(value) {
			this.currentId = null;
			this.isPotentialClient = value;
		},
		onEdit({ line }) {
			this.currentId = line.id;
			this.isPotentialClient = true;
		},
		getRemoveItem(id) {
			this.removeItem = id;
			this.isRemove = true;
		},
		async onRemoveItem() {
			await this.onRemovePotentialClients(this.removeItem);
			this.isRemove = false;
		},
	},
	created() {
		this.tabList = getClonedObject(potentialClientsTabs);
	},
	async mounted() {
		await this.onPotentialClientsFilter({ type: this.type });
	}
};
</script>

<style scoped lang="scss">
@import "potentialClient";
</style>
